import { ApiFetcher } from '@/utils/api-service';
import { appEnvs } from '@/utils/env-mapper';
import { ReactElement, useState } from 'react';

function getAppEnv() {
  let appEnv = appEnvs[window.location.host];

  if (!appEnv) {
    console.info("Can't detect domain ENV, fallback to default ENV");
    appEnv = appEnvs.default;
  }
  return appEnv;
}

export function CurrentCtxInitializer({
  children
}: {
  children: ReactElement;
}) {
  useState(() => {
    const appEnv = getAppEnv();

    // Init default value for current ctx
    window.currentCtx = {
      appEnv
    } as any;

    // Init api fetcher
    window.apiFetcher = new ApiFetcher(appEnv.apiHost);
  });

  return <>{children}</>;
}
